module.exports = __webpack_public_path__ + "img/ic_chat_btn_cal.d5c6da4c.svg";